// file: ./src/js/modules/cdc-steps-modal.js

/**
 * Modulo JS per la gestione della modal con gli step dettagliati
 * della cooperativa di comunità.
 */
export default function initCDCStepsModal(dataScriptId = "cdc-steps-data") {

    // Script JSON con i dati degli step
    const dataScript = document.getElementById(dataScriptId);
    if (!dataScript) return;

    let steps = [];
    try {
        steps = JSON.parse(dataScript.textContent);
    } catch (e) {
        console.error(`JSON ${dataScriptId} non valido`, e);
        return;
    }

    if (!Array.isArray(steps) || steps.length === 0) {
        return;
    }

    const modal = document.getElementById("coopStepsModal");
    const titleEl = document.getElementById("coopStepsModalTitle");
    const iconEl = document.getElementById("coopStepsModalIcon");
    const bodyEl = document.getElementById("coopStepsModalContent");
    const nextBtn = document.getElementById("coopStepsModalNext");
    const closeBtn = document.getElementById("coopStepsModalClose");
    const liveRegion = document.getElementById("coopStepsLiveRegion");

    if (!modal || !titleEl || !iconEl || !bodyEl || !nextBtn) {
        return;
    }

    let current = null;

    // Funzioni di utilità

    function getStep(num) {
        return steps.find(s => Number(s.number) === Number(num)) || null;
    }

    function getNext(num) {
        return steps.find(s => Number(s.number) === Number(num + 1)) || null;
    }

    function getPrev(num) {
        return steps.find(s => Number(s.number) === Number(num - 1)) || null;
    }

    function loadStep(num) {
        const step = getStep(num);
        if (!step) return;

        current = Number(step.number);

        // Titolo
        titleEl.textContent = `${step.number} - ${step.title}`;

        // Icona
        iconEl.innerHTML = step.icon
            ? `<img src="${step.icon}" class="img-fluid mb-2" alt="" aria-hidden="true" width="64" height="64">`
            : "";

        // Contenuto dello step
        bodyEl.innerHTML = step.long;

        // Accessibilità → ARIA live
        if (liveRegion) {
            liveRegion.textContent = `Step ${step.number}`; // `Step ${step.number}: ${step.title}`;
        }

        // Step successivo
        const next = getNext(step.number);

        if (next) {
            closeBtn.classList.add("d-none");
            nextBtn.style.display = "inline-block";
            nextBtn.innerHTML = `Step ${next.number} <span class="icon-arrow-right-l" aria-hidden="true"></span>`;
            nextBtn.dataset.nextStep = String(next.number);
        } else {
            nextBtn.style.display = "none";
            nextBtn.dataset.nextStep = "";
            closeBtn.classList.remove("d-none");
        }
    }

    // Utilizziamo jQuery esclusivamente per gestire l'evento di apertura della modal Bootstrap
    // .js-open-step → pulsante o link che apre la modal
    jQuery('.js-open-step').on('click', function () {
        const n = Number(this.dataset.step);
        if (!Number.isNaN(n)) {
            loadStep(n);
        }
    });

    // Click → next step
    nextBtn.addEventListener('click', function () {
        const next = Number(this.dataset.nextStep);
        if (next) {
            loadStep(next);
        }
    });

    // Accessibilità → navigazione con tastiera
    document.addEventListener('keydown', function (e) {

        if (!modal.classList.contains('show')) return;

        const key = e.key;

        // Next → freccia destra o Enter
        if (key === 'ArrowRight' || key === 'Enter') {
            const next = getNext(current);
            if (next) {
                e.preventDefault();
                loadStep(next.number);
            }
        }

        // Prev → freccia sinistra
        if (key === 'ArrowLeft') {
            const prev = getPrev(current);
            if (prev) {
                e.preventDefault();
                loadStep(prev.number);
            }
        }
    });
}
